// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__ajKAJ","inputWrap":"styles_inputWrap__1XA21","input":"styles_input__3Bwrt"};